const isRgb = (string) => string.includes('rgb');
const isBlack = (rgboArray) => rgboArray.slice(0, 3).every(colorValue => colorValue === 0);
const isWhite = (rgboArray) => rgboArray.slice(0, 3).every(colorValue => colorValue === 255);
const arrayifyRgb = (rgbString) => {
    const [a, b, c, d] = rgbString.split(',');
    return [
        Number(a.split('(')[1]),
        Number(b),
        Number(c),
        Number(d.split(')')[0]),
    ];
};
const convertToFraction = (opacity) => Number(opacity.slice(0, -1)) / 100;
const hexToRgbo = (hex) => {
    const r = parseInt(hex.substr(1, 2), 16); // Grab the hex representation of red (chars 1-2) and convert to decimal (base 10).
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);
    const o = 1;
    return [r, g, b, o];
};
// This function darkens a color, unless that color is black, in which case it lightens it
const addsDarkMaskToRgbo = (baseLayer) => {
    let mask;
    let opacity;
    if (isBlack(baseLayer)) {
        mask = [255, 255, 255];
        opacity = 0.15;
    }
    else {
        mask = [0, 0, 0];
        opacity = 0.1;
    }
    const [r, g, b] = mask.map((color, index) => opacity * color + (1 - opacity) * baseLayer[index]);
    const baseLayerOpacity = baseLayer[3];
    return `rgb(${r}, ${g}, ${b}, ${baseLayerOpacity})`;
};
// This function lightens a color, unless that color is white, in which case it darkens it
const addsLightMaskToRgbo = (baseLayer) => {
    let mask;
    let opacity;
    if (isWhite(baseLayer)) {
        mask = [0, 0, 0];
        opacity = 0.15;
    }
    else {
        mask = [255, 255, 255];
        opacity = 0.1;
    }
    const [r, g, b] = mask.map((color, index) => opacity * color + (1 - opacity) * baseLayer[index]);
    const baseLayerOpacity = baseLayer[3];
    return `rgb(${r}, ${g}, ${b}, ${baseLayerOpacity})`;
};
const addsBackgroundlessMask = (expectedBackdrop, lighten) => {
    if (isBlack(expectedBackdrop)) {
        return lighten ? 'rgb(255, 255, 255, 0.1)' : 'rgb(255, 255, 255, 0.15)';
    }
    else if (isWhite(expectedBackdrop)) {
        return lighten ? 'rgb(0, 0, 0, 0.15)' : 'rgb(0, 0, 0, 0.1)';
    }
    else {
        return lighten ? 'rgb(255, 255, 255, 0.1)' : 'rgb(0, 0, 0, 0.1)';
    }
};
const addsMask = ({ backgroundless = false, color, isBackgroundColor = false, lighten = false, props, }) => {
    let originalColor;
    if (isBackgroundColor) {
        originalColor = props.theme.colors.background[color];
    }
    else {
        originalColor = props.theme.colors.content[color];
    }
    const rgbArray = isRgb(originalColor)
        ? arrayifyRgb(originalColor)
        : hexToRgbo(originalColor);
    if (backgroundless) {
        return addsBackgroundlessMask(rgbArray, lighten);
    }
    else {
        return lighten
            ? addsLightMaskToRgbo(rgbArray)
            : addsDarkMaskToRgbo(rgbArray);
    }
};
const addsOpacity = ({ color, opacity, }) => {
    const opacityFraction = convertToFraction(opacity);
    const newColor = isRgb(color) ? arrayifyRgb(color) : hexToRgbo(color);
    const [r, g, b, o] = newColor;
    const newOpacity = o - (1 - opacityFraction * o);
    const updatedRgbo = `rgb(${r}, ${g}, ${b}, ${newOpacity})`;
    return updatedRgbo;
};

export { addsMask, addsOpacity };
